import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Store } from '@ngrx/store';

import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { selectDealerMyCarPark, selectJob, selectLoggedInUserData, selectLoggedInUserDataId, selectProviderOffer } from 'src/app/common/store/state/app.state';
import { DealerActions } from 'src/app/common/store/actions/dealer.actions';
import { KeepActions } from 'src/app/common/store/actions/keep.actions';
import { FormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { Dealer } from 'src/app/public/account/models/dealer.model';
import { Car } from 'src/app/public/car/models/car.model';
import { CommonBasicData, ServiceType } from 'src/app/public/common/constants/common-basic-data';
import { ObjectData } from 'src/app/public/common/models/object-data.model';
import { KeepBasicData, JobAction } from '../../constants/keep-basic-data';
import { JobModif } from '../../models/job-modif.model';
import { Job } from '../../models/job.model';
import { AsyncPipe } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';


@Component({
    selector: 'app-job-dialog',
    templateUrl: './job-dialog.component.html',
    styleUrls: ['./job-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, MatFormFieldModule, MatInputModule, MatDialogModule, MatIconModule, MatDatepickerModule, MatSlideToggleModule, MatSelectModule, AsyncPipe]
})
export class JobDialogComponent implements OnInit{

  job$ : Observable<Job | undefined>;
  job: Job = new Job();

  currentUserId$ : Observable<string>;
  currentUserId: string = "";

  currentUser$ : Observable<Dealer>;
  currentUser: Dealer = new Dealer()

  myCars$ : Observable<Car[]>;
  myCars: Car[] = [];

  selectedCar$ : Observable<Car | null>;
  selectedCar: Car = new Car();

  disabled = false;

  serviceTypesBD = CommonBasicData.serviceTypes;
  jobTypesBD = KeepBasicData.jobTypes;
  jobCategoriesBD = KeepBasicData.carJobCategories;
  locationModesBD = CommonBasicData.locationModes;
  
  isNew: boolean = false;

  ServiceType = ServiceType

  isModification: boolean = false;
  isCompletion: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<JobDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ObjectData,
    private store: Store,
    private router: Router, 
    private route: ActivatedRoute) {

      this.currentUserId$ = store.select(selectLoggedInUserDataId);
      this.currentUser$ = store.select(selectLoggedInUserData);
      this.job$ = store.select(selectJob( data.objectSource, data.offerId, ""+data.objectId, data.carId )); 
      this.myCars$ = store.select(selectDealerMyCarPark);

      this.selectedCar$ = store.select(selectProviderOffer(data.objectSource, data.carId, data.businessLine, data.offerId) );
    }

    ngOnInit(): void {

      this.store.dispatch(DealerActions.fetchProviderParkSubmit()); 

      this.isNew = (this.data.objectId ===0);
      console.log(this.data.offerId)

      this.job.offerId = this.data.offerId
      this.job.carId = this.data.carId
      this.job.jobId = ""+this.data.objectId

      this.currentUserId$.subscribe(
          (id: string) => this.currentUserId = id
      );

      this.currentUser$.subscribe(
          (usr: Dealer) => this.currentUser = usr
      );

      this.selectedCar$.subscribe(
          (car: Car | null) => this.selectedCar = car!
      );

      this.job$.subscribe(
        (jb: Job | undefined) => {
          
          if(jb === undefined){

            console.log("1 ghhhhhhhhhh ")
            this.job = new Job()
            this.job.offerId = this.data.offerId
            this.job.carId = this.data.carId
            this.job.jobId = ""+this.data.objectId
          }
          else{
            console.log("2 ghhhhhhhhhh ")
            this.job = JSON.parse(JSON.stringify(jb))
          }
          
          console.log(this.job.offerId)

          //this.job.offerId = this.data.offerId
        }
      );

      this.isCompletion = this.data.objectAction! === JobAction.COMPLETE
      this.isModification = this.data.objectAction! === JobAction.EDIT_MODIF

      if(this.isModification && this.job.modification === null){
        this.job.modification = new JobModif();
        this.job.modification.jobId = this.job.jobId
      }
    } 
  
  onNoClick(): void {
    this.dialogRef.close();
  }

  submitJobOld(){

    console.log(this.job)
        
    if(+this.job.jobId > 0){
      //this.store.dispatch(KeepActions.jobUpdateSubmit ( { job: this.job, objectSource: this.data.objectSource })); 
      this.store.dispatch(KeepActions.jobActionSubmit ( { jobAction: JobAction.EDIT, job: this.job, objectSource: this.data.objectSource })); 
    }
    else{
      if(this.job.serviceType === ServiceType.INTERMEDIATION){
        this.job.offerId = this.currentUser.keepOffer.offerId
        this.job.carId = this.selectedCar.carId
      }
      this.store.dispatch(KeepActions.jobNewSubmit ( { job: this.job, objectSource: this.data.objectSource }));
    }
    this.dialogRef.close();
  }



  submitJob(){
      
    if(this.job.jobId === ''){
      console.log('new')
      this.store.dispatch(KeepActions.jobNewSubmit({ job: this.job, objectSource: this.data.objectSource }));
    }
    else{
      if(this.isModification){
        console.log('modif')
        //this.store.dispatch(BuyActions.jobRescheduleSubmit ( { jobId: this.job.id, rescDate: this.job.rescheduleDate, objectSource: this.data.objectSource }));
        this.store.dispatch(KeepActions.jobActionSubmit({ jobAction: JobAction.EDIT_MODIF, job: this.job.modification!, objectSource: this.data.objectSource }));
      }

      else{
        console.log('update or complete')
        this.store.dispatch(KeepActions.jobActionSubmit({ jobAction: this.data.objectAction as JobAction, job: this.job, objectSource: this.data.objectSource }));         
      } 
    }
    this.dialogRef.close();
  }

  onLocationModeChange(){

  }

  onEmergencyChange(){

  }
}
